module.exports = __webpack_public_path__ + "static/media/button-active.23f53e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/login-register/button-active.png
// module id = 32
// module chunks = 1